import React, {useEffect, useState} from 'react'
import Tr from 'translations/Translations';
import Dialog from 'components/Dialog';
import GridBlock from 'components/GridBlock';
import Form from 'components/Form';
import * as Yup from 'yup';
import useId from 'hooks/useId';
import {connect} from 'react-redux'
import {makeStyles} from "@material-ui/core";
import DoubleButton from "components/popup/components/DoubleButton";
import DateTimePicker from "components/DateTimePicker";
import Select from "components/Select";
import DescriptionIcon from '@material-ui/icons/Description';
import FolderIcon from '@material-ui/icons/Folder';
import TypographyWithIcon from "components/TypographyWithIcon";
import moment from "libs/moment";
import VS from "constants/ValidationShema";
import RepoService from "services/RepoService";

const useStyle = makeStyles(theme => ({
    margin: {
        marginBottom: theme.spacing(2)
    }
}));

function ChangeRepoVisibilityPopup(
    {
        onClose = () => {
        },
        demandId,
        repoVisibility,
        formSubmit,
        repoVisibilityTypes
    }) {


    const {fileId, folderId, name, visibilityStatus, visibilityEndDate} = repoVisibility;
    const isFile = !!fileId;
    const classes = useStyle();
    const formId = useId();
    const handleSubmit = () => formSubmit[formId]();

    const [visibilityTypes, setVisibilityTypes] = useState([]);

    useEffect(() => {
        const types = [];
        Object.keys(repoVisibilityTypes).forEach((x) => types.push({label: repoVisibilityTypes[x], value: x}));
        setVisibilityTypes(types);
    }, [repoVisibilityTypes]);


    const onSubmit = (values) => {
        let promise;
        if (isFile) {
            promise = RepoService.changeFileVisibility(demandId, folderId, fileId, values);
        } else {
            promise = RepoService.changeFolderFilesVisibility(demandId, folderId, values);
        }
        promise.then(onClose);

    }

    const validationSchema = VS.lazy((value) => {

        let objShape = {
            visibility: VS.string(),
        }

        if (value.visibility !== 'STATUS_INTERNAL') {
            objShape['visibilityEndDate'] = VS.dateTimeNoReq()
        }

        return Yup.object().shape(objShape)
    })

    return (
        <Dialog
            title={isFile ? Tr('change_file_visibility') : Tr('change_visibility_for_all_files')}
            open={true}
            maxWidth={'xs'}
            dialogActions={<DoubleButton
                justify='flex-end'
                labelFirst={Tr('cancel')}
                labelSecond={Tr('confirm')}
                onClickFirst={onClose}
                onClickSecond={handleSubmit}
            />}
        >

            <Form
                initialValues={{
                    visibility: visibilityStatus,
                    visibilityEndDate: visibilityEndDate ? moment(visibilityEndDate) : null,
                }}
                validationSchema={validationSchema}
                onSubmit={onSubmit}
                id={formId}
            >
                {(formikProps) => (
                    <GridBlock column>

                        <TypographyWithIcon Icon={isFile ? DescriptionIcon : FolderIcon} className={classes.margin}>
                            {name}
                        </TypographyWithIcon>

                        <Select
                            id='visibility'
                            formikProps={formikProps}
                            items={visibilityTypes}
                            label={Tr('repo_visibility_type')}
                        />

                        <DateTimePicker
                            formikProps={formikProps}
                            id='visibilityEndDate'
                            label={Tr('repo_visibility_end_date')}
                            disabled={formikProps.values.visibility === 'STATUS_INTERNAL'}
                        />
                    </GridBlock>
                )}
            </Form>
        </Dialog>
    )
}

export default connect((state) => ({
    formSubmit: state.form,
    repoVisibilityTypes: state.resources.repoVisibilityTypes
}), {})(ChangeRepoVisibilityPopup);